import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const updateRecipeApi = async (recipeData) => {
  const response = await axiosInstance.post(
    `${Endpoints.UPDATE_STANDARD_RECIPES}`,
    recipeData
  );
  return response.data;
};

export const deleteRecipeByIdApi = async (recipeId) => {
  const response = await axiosInstance.delete(
    `${Endpoints.DELETE_STANDARD_RECIPE_BY_ID}${recipeId}`
  );
  return response.data;
};
